import { useCallback, useState } from 'react';
import { recoverPassword } from 'services/authService';

export const useRecoverPassword = () => {
  const [isRecovering, setIsRecovering] = useState(false);
  const [recoverError, setRecoverError] = useState(null);
  const [lastResult, setLastResult] = useState(null);

  const executeRecover = useCallback(async ({ email }) => {
    setIsRecovering(true);
    setRecoverError(null);

    try {
      const result = await recoverPassword(email);

      setLastResult(result);

      return { ok: true, data: result };
    } catch (error) {
      console.error('Error recovering password:', error);
      setRecoverError(error);

      return { ok: false, error };
    } finally {
      setIsRecovering(false);
    }
  }, []);

  return {
    recoverPassword: executeRecover,
    isRecovering,
    recoverError,
    lastResult,
  };
};
